import React from 'react';
import { CenteredMessage } from '../../../components/layout/CenteredMessage';

export const HostStartingView: React.FC = () => {
    return <CenteredMessage>Get Ready! The game is about to begin...</CenteredMessage>;
};
